import React from "react";
import "../../css/contact.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { telegram, whatsapp } from "../../constans/ColorConstants";

const Contact = () => {
  const { t } = useTranslation();
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="contact-page">
      <Header />
      <main className="contact__container">
        <h1 className="contact__title">{t("contact.title")}</h1>
        <p className="contact__intro">{t("contact.intro")}</p>
        <Link onClick={toTop} className="contact__btn" to="/help">
          {t("contact.helpBtn")}
        </Link>

        <div className="contact__grid">
          <section className="contact-card contact-card--center">
            <div className="contact-card__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm0 18.2A8.2 8.2 0 1 1 12 3.8a8.2 8.2 0 0 1 0 16.4z" />
                <path d="M12.75 7.5a.75.75 0 0 0-1.5 0v5c0 .2.08.39.22.53l3 3a.75.75 0 1 0 1.06-1.06l-2.78-2.78V7.5z" />
              </svg>
            </div>
            <h3 className="contact-card__title">
              {t("contact.cards.hoursTitle")}
            </h3>
            <p className="contact-card__text">{t("contact.cards.hoursText")}</p>
          </section>

          <section className="contact-card">
            <div className="contact-card__icon">
              <svg
                t="1773630022609"
                class="icon"
                viewBox="0 0 1280 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2548"
                width="200"
                height="200"
              >
                <path
                  d="M976.04562 384H672.04562v112c0 79.4-64.6 144-144 144s-144-64.6-144-144V252.8l-129.8 78C215.64562 353.8 192.04562 395.6 192.04562 440.4v94.6l-160 92.4C1.44562 645-9.15438 684.2 8.64562 714.8l160 277.2c17.6 30.6 56.8 41 87.4 23.4L462.84562 896H736.04562c70.6 0 128-57.4 128-128h32c35.4 0 64-28.6 64-64v-128h16c26.6 0 48-21.4 48-48v-96c0-26.6-21.4-48-48-48z m295.4-74.8L1111.44562 32C1093.84562 1.4 1054.64562-9 1024.04562 8.6L817.24562 128H612.84562c-24 0-47.4 6.8-67.8 19.4L478.04562 189.2c-18.8 11.6-30 32.2-30 54.2V496c0 44.2 35.8 80 80 80s80-35.8 80-80v-176h368c61.8 0 112 50.2 112 112v57l160-92.4c30.6-17.8 41-56.8 23.4-87.4z"
                  p-id="2549"
                ></path>
              </svg>
            </div>
            <h3 className="contact-card__title">
              {t("contact.cards.contactTitle")}
            </h3>
            <p
              className="contact-card__text"
              dangerouslySetInnerHTML={{
                __html: t("contact.cards.contactIntro"),
              }}
            />
            <ul className="contact-card__list">
              <li>
                <a
                  href={whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    t="1773630162177"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4404"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M784.096 240.096A379.872 379.872 0 0 0 513.6 128C302.848 128 131.296 299.488 131.2 510.24a381.312 381.312 0 0 0 51.04 191.104L128 899.456l202.72-53.152a382.176 382.176 0 0 0 182.752 46.528h0.16c210.752 0 382.304-171.488 382.4-382.272a380.16 380.16 0 0 0-111.936-270.464z m-270.496 588.16h-0.128a317.44 317.44 0 0 1-161.76-44.288l-11.616-6.88-120.288 31.552 32.096-117.248-7.552-12.032a317.216 317.216 0 0 1-48.608-169.088c0.064-175.2 142.656-317.696 317.952-317.696 84.896 0.032 164.704 33.12 224.704 93.184s93.024 139.872 92.992 224.768c-0.032 175.2-142.592 317.728-317.792 317.728z m174.336-237.952c-9.568-4.768-56.544-27.904-65.28-31.072-8.768-3.2-15.136-4.768-21.504 4.768-6.368 9.568-24.672 31.072-30.24 37.44-5.568 6.368-11.136 7.168-20.704 2.4-9.568-4.768-40.352-14.88-76.832-47.424-28.416-25.312-47.584-56.608-53.152-66.176-5.568-9.568-0.608-14.72 4.192-19.488 4.288-4.288 9.568-11.168 14.336-16.736s6.368-9.568 9.568-15.936 1.6-11.968-0.8-16.736-21.504-51.808-29.472-70.912c-7.744-18.624-15.648-16.096-21.504-16.384-5.568-0.288-11.936-0.32-18.304-0.32-6.368 0-16.736 2.4-25.472 11.968s-33.44 32.672-33.44 79.68 34.24 92.448 39.008 98.816 67.36 102.848 163.232 144.224c22.784 9.824 40.608 15.712 54.464 20.128 22.88 7.264 43.712 6.24 60.192 3.776 18.368-2.752 56.544-23.104 64.48-45.408 7.968-22.304 7.968-41.44 5.568-45.408-2.4-4.032-8.768-6.432-18.336-11.2z"
                      p-id="4405"
                      fill="#1a1a1a"
                    ></path>
                  </svg>
                  {t("contact.cards.whatsapp")}
                </a>
              </li>
              <li>
                <a
                  href={telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    t="1773630207834"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5463"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M512 16C238 16 16 238 16 512s222 496 496 496 496-222 496-496S786 16 512 16z m243.6 339.8l-81.4 383.6c-6 27.2-22.2 33.8-44.8 21l-124-91.4-59.8 57.6c-6.6 6.6-12.2 12.2-25 12.2l8.8-126.2 229.8-207.6c10-8.8-2.2-13.8-15.4-5l-284 178.8-122.4-38.2c-26.6-8.4-27.2-26.6 5.6-39.4l478.2-184.4c22.2-8 41.6 5.4 34.4 39z"
                      fill="#1a1a1a"
                      p-id="5464"
                    ></path>
                  </svg>
                  {t("contact.cards.telegram")}
                </a>
              </li>
            </ul>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
